// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkersForm_wrapperButton__tsRzX .WorkersForm_file_block__nS39V {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.WorkersForm_rightBlock__WWiHR {
  display: flex;
  gap: 20px;
}
.WorkersForm_rightBlock__info__\\+58tp {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.WorkersForm_infoBlocks__Ta3AJ {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.WorkersForm_infoBlock__54Hzo {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.5);
}
.WorkersForm_infoBlock__top__k7b\\+6 {
  display: flex;
  gap: 20px;
  align-items: flex-end;
}
.WorkersForm_infoBlock__main__4ZwKw {
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  align-items: center;
}
.WorkersForm_infoBlock__bottom__9Pu0I {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  align-items: center;
}
.WorkersForm_infoBlock__bottom__9Pu0I a {
  display: flex;
}
.WorkersForm_infoBlock__54Hzo .WorkersForm_partnerConfirm__XGrSb {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.WorkersForm_infoBlock__54Hzo .WorkersForm_adminConfirm__4l5pp {
  display: flex;
  gap: 20px;
  flex-direction: column;
}

.WorkersForm_overlayWrapper__xiLGu {
  position: relative;
  width: 300px;
  height: 350px;
  border: 1px solid black;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.WorkersForm_overlayWrapper__xiLGu .WorkersForm_overlay__sAA8R {
  position: absolute;
  padding: 20px;
  top: 0;
  font-size: 14px;
  width: 100%;
  height: 100%;
  transform: translateY(-100%);
  opacity: 0;
  transition: all 0.5s ease, transform 0.5s ease;
}
.WorkersForm_overlayWrapper__xiLGu:hover .WorkersForm_overlay__sAA8R {
  transform: translateY(0%);
  opacity: 1;
  background-color: rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/views/workers/WorkersForm.module.scss"],"names":[],"mappings":"AACE;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;;AAMA;EACE,aAAA;EACA,SAAA;AAHF;AAKE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHJ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EAGA,iBAAA;EACA,oBAAA;EACA,iDAAA;AANF;AAQE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AANJ;AASE;EACE,aAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;AAPJ;AAUE;EACE,aAAA;EACA,2BAAA;EACA,SAAA;EACA,mBAAA;AARJ;AAWI;EACE,aAAA;AATN;AAaE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAXJ;AAcE;EACE,aAAA;EACA,SAAA;EAEA,sBAAA;AAbJ;;AAkBA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAfF;AAiBE;EACE,kBAAA;EACA,aAAA;EACA,MAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,UAAA;EACA,8CAAA;AAfJ;AAkBE;EACE,yBAAA;EACA,UAAA;EACA,oCAAA;AAhBJ","sourcesContent":[".wrapperButton {\n  .file_block {\n    // border: 1px solid;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 10px;\n  }\n}\n\n\n.rightBlock {\n  display: flex;\n  gap: 20px;\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n}\n\n.infoBlocks {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.infoBlock {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 20px;\n\n  //\n  padding-top: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(128, 128, 128, 0.5);\n\n  &__top {\n    display: flex;\n    gap: 20px;\n    align-items: flex-end;\n  }\n\n  &__main {\n    display: flex;\n    gap: 20px;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  &__bottom {\n    display: flex;\n    justify-content: flex-start;\n    gap: 20px;\n    align-items: center;\n\n\n    a {\n      display: flex;\n    }\n  }\n\n  .partnerConfirm {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .adminConfirm {\n    display: flex;\n    gap: 20px;\n\n    flex-direction: column;\n  }\n}\n\n\n.overlayWrapper {\n  position: relative;\n  width: 300px;\n  height: 350px;\n  border: 1px solid black;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n\n  .overlay {\n    position: absolute;\n    padding: 20px;\n    top: 0;\n    font-size: 14px;\n    width: 100%;\n    height: 100%;\n    transform: translateY(-100%);\n    opacity: 0;\n    transition: all 0.5s ease, transform 0.5s ease;\n  }\n\n  &:hover .overlay {\n    transform: translateY(0%);\n    opacity: 1;\n    background-color: rgb(255, 255, 255);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperButton": `WorkersForm_wrapperButton__tsRzX`,
	"file_block": `WorkersForm_file_block__nS39V`,
	"rightBlock": `WorkersForm_rightBlock__WWiHR`,
	"rightBlock__info": `WorkersForm_rightBlock__info__+58tp`,
	"infoBlocks": `WorkersForm_infoBlocks__Ta3AJ`,
	"infoBlock": `WorkersForm_infoBlock__54Hzo`,
	"infoBlock__top": `WorkersForm_infoBlock__top__k7b+6`,
	"infoBlock__main": `WorkersForm_infoBlock__main__4ZwKw`,
	"infoBlock__bottom": `WorkersForm_infoBlock__bottom__9Pu0I`,
	"partnerConfirm": `WorkersForm_partnerConfirm__XGrSb`,
	"adminConfirm": `WorkersForm_adminConfirm__4l5pp`,
	"overlayWrapper": `WorkersForm_overlayWrapper__xiLGu`,
	"overlay": `WorkersForm_overlay__sAA8R`
};
export default ___CSS_LOADER_EXPORT___;
